<script>
import { format } from 'date-fns';
import { nl } from 'date-fns/locale';
import ScrollIndicator from '@/components/ScrollIndicator.vue';

export default {
  name: 'PerformanceChartHourly',
  components: { ScrollIndicator },
  emits: [],
  mixins: [],
  props: {
    chartData: {},
  },
  data() {
    return {
      showLeftBlur: true,
      showRightBlur: false,
    };
  },
  computed: {
    chartWidth() {
      const barWidth = 20;
      return Math.max(this.chartData.length * barWidth, 300);
    },
    chartDataSet() {
      return {
        datasets: [
          {
            yAxisId: 'y',
            data: this.chartData,
            parsing: {
              xAxisKey: 'start_date',
              yAxisKey: 'actual_yield_in_kwh',
            },
            borderRadius: 12,
            backgroundColor: () =>
              getComputedStyle(document.documentElement)
                .getPropertyValue('--color-background-chart')
                .trim(),
          },
        ],
      };
    },
    chartOptions() {
      return {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            backgroundColor: '#334155',
            yAlign: 'bottom',
            displayColors: false,
            titleFont: {
              size: 16,
            },
            bodyFont: {
              size: 15,
            },
            callbacks: {
              title: (contexts) => {
                return this.formatDateTime(contexts[0].label);
              },
              label: (data) => {
                const value =
                  data.dataset.data[data.dataIndex].actual_yield_in_kwh;
                return value.toFixed(2) + ' kWh';
              },
            },
          },
        },
        scales: {
          y: {
            ticks: { count: 6 },
            border: {
              display: false,
            },
          },
          y1: {
            position: 'right',
            border: {
              display: false,
            },
            afterBuildTicks: (axis) => {
              axis.ticks = [...axis.chart.scales.y.ticks];
              axis.min = axis.chart.scales.y.min;
              axis.max = axis.chart.scales.y.max;
            },
          },
          x: {
            grid: {
              display: false,
            },
            ticks: {
              callback: (index) => {
                const time = new Date(this.chartData[index].start_date);
                return time.getHours() === 12
                  ? format(time, 'dd MMMM', { locale: nl })
                  : null;
              },
            },
          },
        },
      };
    },
  },
  methods: {
    formatDateTime(dateOrString) {
      const d =
        dateOrString instanceof Date ? dateOrString : new Date(dateOrString);
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');

      return `${dd}-${mm} ${hh}:${min}`;
    },
  },
};
</script>

<template>
    <ScrollIndicator scroll-direction="rtl" :watch-target="chartData" class="border rounded-xl">
      <Chart
        type="bar"
        :data="chartDataSet"
        :options="chartOptions"
        :width="chartWidth"
        :height="250"
        :style="{ minWidth: chartWidth + 'px', }"
        class="m-3"
        dir="ltr"
      />
    </ScrollIndicator>
</template>

<style scoped></style>
